<template lang="pug">
    v-main
        Header
        ForgetPassword
        
</template>

<script>
import Header from "../components/SignupCard.vue";
import ForgetPassword from "../components/ForgetPasswordCard.vue";
export default {
  components: {
    Header,
    ForgetPassword
  }
};
</script>

<style>
.bg {
 /* background: url("../assets/bliss.jpg"); */
  background-size: cover;
}
</style>


